import React__default from 'react';
import { HorizontalHeading } from './HorizontalHeading.js';
import { PopoverHeading } from './PopoverHeading.js';

const Headings = ({ type, heading, tabs, activeTabType, setActiveTabType, horizontalText, showOneHorizontalTabHeading, isLimitTabsCount, }) => {
    if (!activeTabType)
        return null;
    const handleTabChange = (tab) => {
        setActiveTabType(tab);
    };
    const props = {
        tabs,
        element: heading,
        activeTabType,
        onTabChange: handleTabChange,
    };
    if (type === 'horizontal') {
        return (React__default.createElement(HorizontalHeading, { ...props, horizontalText: horizontalText, showOneHorizontalTabHeading: showOneHorizontalTabHeading }));
    }
    return React__default.createElement(PopoverHeading, { isLimitTabsCount: isLimitTabsCount, ...props });
};

export { Headings };
//# sourceMappingURL=Headings.js.map
